/* TALVORE v3 — apertura de cine, letrero, recorrido horizontal y dúo */
(function () {
  if (window.mtV3) return;
  window.mtV3 = true;
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- Apertura de cine ---------- */
  function initCine(sec) {
    if (sec.dataset.mtListo) return;
    sec.dataset.mtListo = '1';
    var escenas = sec.querySelectorAll('.mt-cine__escena'), historias = sec.querySelectorAll('.mt-cine__historia');
    var num = sec.querySelector('[data-mt-cine-num]'), hora = sec.querySelector('[data-mt-hora]'), texto = sec.querySelector('[data-mt-cine-texto]');
    var dur = (parseFloat(getComputedStyle(sec).getPropertyValue('--mt-dur')) || 6) * 1000, actual = 0, timer;
    function ir(i) {
      if (!escenas.length) return;
      var prev = actual;
      actual = (i + escenas.length) % escenas.length;
      escenas.forEach(function (e, k) {
        e.classList.toggle('mt-saliendo', k === prev && k !== actual);
        e.classList.toggle('mt-activa', k === actual);
        if (k === actual) { var img = e.querySelector('img'); if (img) { img.style.animation = 'none'; img.offsetWidth; img.style.animation = ''; } }
      });
      historias.forEach(function (h, k) {
        h.classList.toggle('mt-activa', k === actual);
        h.classList.toggle('mt-vista', k < actual);
        var b = h.querySelector('.mt-cine__barra i'); if (b) { b.style.animation = 'none'; b.offsetWidth; b.style.animation = ''; }
      });
      if (num) num.textContent = ('0' + (actual + 1)).slice(-2);
      sec.querySelectorAll('.mt-cine__ficha').forEach(function (f) { f.classList.toggle('mt-activa', +f.dataset.i === actual); });
      programar();
    }
    function programar() {
      clearTimeout(timer);
      if (reducido || escenas.length < 2) return;
      timer = setTimeout(function () { if (!document.hidden) ir(actual + 1); else programar(); }, dur);
    }
    historias.forEach(function (h, k) { h.addEventListener('click', function () { ir(k); }); });
    programar();
    /* hora real */
    if (hora) {
      var tick = function () { var d = new Date(); hora.textContent = [d.getHours(), d.getMinutes(), d.getSeconds()].map(function (n) { return ('0' + n).slice(-2); }).join(':'); };
      tick(); setInterval(tick, 1000);
    }
    /* el texto se eleva y se desvanece al bajar */
    if (texto && !reducido) {
      window.addEventListener('scroll', function () {
        var y = window.scrollY, h = sec.offsetHeight;
        if (y > h) return;
        var p = y / h;
        texto.style.transform = 'translate3d(0,' + (-p * 120) + 'px,0)';
        texto.style.opacity = String(Math.max(0, 1 - p * 1.6));
      }, { passive: true });
    }
  }

  /* ---------- Letrero: se desplaza solo y acelera con el scroll ---------- */
  var letreros = [], ultimoY = window.scrollY, boost = 1, tPrev = 0;
  function initLetrero(sec) {
    if (sec.dataset.mtListo) return;
    sec.dataset.mtListo = '1';
    sec.classList.add('mt-js');
    var vel = parseFloat(getComputedStyle(sec.querySelector('.mt-letrero__fila')).getPropertyValue('--mt-vel')) || 50;
    sec.querySelectorAll('.mt-letrero__pista').forEach(function (p, k) { letreros.push({ sec: sec, p: p, x: 0, dir: k % 2 ? 1 : -1, vel: vel, pausa: false }); });
    sec.addEventListener('mouseenter', function () { letreros.forEach(function (l) { if (l.sec === sec) l.pausa = true; }); });
    sec.addEventListener('mouseleave', function () { letreros.forEach(function (l) { if (l.sec === sec) l.pausa = false; }); });
  }
  function bucleLetrero(t) {
    var dt = tPrev ? Math.min(64, t - tPrev) : 16; tPrev = t;
    var y = window.scrollY, v = Math.min(8, Math.abs(y - ultimoY) / 6);
    ultimoY = y;
    boost += ((1 + v) - boost) * 0.06;
    letreros.forEach(function (l) {
      var mitad = l.p.scrollWidth / 2; if (!mitad) return;
      var paso = (mitad / (l.vel * 1000)) * dt * (l.pausa ? 0.15 : boost);
      l.x += paso * l.dir;
      if (l.x <= -mitad) l.x += mitad; if (l.x > 0) l.x -= mitad;
      l.p.style.transform = 'translate3d(' + l.x.toFixed(1) + 'px,0,0)';
    });
    requestAnimationFrame(bucleLetrero);
  }

  /* ---------- Recorrido horizontal ---------- */
  var viajes = [];
  function initViaje(sec) {
    if (sec.dataset.mtListo) return;
    sec.dataset.mtListo = '1';
    viajes.push({ sec: sec, pista: sec.querySelector('[data-mt-viaje-pista]'), barra: sec.querySelector('[data-mt-viaje-barra]'), tarjetas: sec.querySelectorAll('.mt-viaje__tarjeta') });
  }
  function moverViajes() {
    var escritorio = window.innerWidth > 990;
    viajes.forEach(function (o) {
      if (!escritorio) { o.pista.style.transform = ''; return; }
      var r = o.sec.getBoundingClientRect(), recorrido = o.sec.offsetHeight - window.innerHeight;
      var p = Math.min(1, Math.max(0, -r.top / Math.max(1, recorrido)));
      var maxX = o.pista.scrollWidth - window.innerWidth;
      o.pista.style.transform = 'translate3d(' + (-p * maxX) + 'px,0,0)';
      if (o.barra) o.barra.style.width = (p * 100) + '%';
      o.tarjetas.forEach(function (t) { var b = t.getBoundingClientRect(); t.classList.toggle('mt-cerca', b.left < window.innerWidth * 0.85 && b.right > window.innerWidth * 0.1); });
    });
  }
  window.addEventListener('scroll', function () { requestAnimationFrame(moverViajes); }, { passive: true });
  window.addEventListener('resize', moverViajes);

  /* ---------- Arma tu dúo ---------- */
  function dinero(c, formato) {
    var n = (c / 100).toFixed(2).split('.'), miles = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return (formato || '{{amount_with_comma_separator}} €')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, miles + ',' + n[1])
      .replace(/\{\{\s*amount\s*\}\}/, n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + n[1])
      .replace(/\{\{\s*amount_no_decimals(_with_comma_separator)?\s*\}\}/, miles);
  }
  function centimos(txt) { var s = String(txt).replace(/[^\d,.]/g, ''); if (/,\d{2}$/.test(s)) s = s.replace(/\./g, '').replace(',', '.'); else s = s.replace(/,/g, ''); return Math.round(parseFloat(s) * 100) || 0; }
  function initDuo(sec) {
    if (sec.dataset.mtListo) return;
    sec.dataset.mtListo = '1';
    var datos; try { datos = JSON.parse(sec.querySelector('[data-mt-duo-datos]').textContent); } catch (e) { return; }
    if (!datos.length) return;
    var desc = (parseFloat(sec.getAttribute('data-descuento')) || 0) / 100, formato = sec.getAttribute('data-moneda');
    var huecos = Array.prototype.map.call(sec.querySelectorAll('[data-mt-hueco]'), function (h) { return { el: h, p: +h.getAttribute('data-p') % datos.length, v: 0 }; });
    var antes = sec.querySelector('[data-mt-duo-antes]'), ahora = sec.querySelector('[data-mt-duo-ahora]'), ahorro = sec.querySelector('[data-mt-duo-ahorro]'), btn = sec.querySelector('[data-mt-duo-btn]');
    function pintar(h, animar) {
      var m = datos[h.p], v = m.variantes[h.v] || m.variantes[0];
      h.el.querySelectorAll('.mt-duo__modelo').forEach(function (b) { var on = +b.dataset.p === h.p; b.classList.toggle('mt-activo', on); b.setAttribute('aria-pressed', on); });
      var cont = h.el.querySelector('[data-mt-duo-esferas]');
      cont.innerHTML = '';
      m.variantes.forEach(function (x, i) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'mt-dial mt-dial--med' + (i === h.v ? ' mt-activo' : '');
        b.style.setProperty('--c', x.color); b.dataset.i = i; b.dataset.nombre = x.nombre; b.setAttribute('aria-label', x.nombre);
        b.innerHTML = '<span class="mt-dial__bisel"></span><span class="mt-dial__cara">' + (x.esfera ? '<img src="' + x.esfera + '" alt="" onerror="this.remove()">' : '') + '</span><span class="mt-dial__brillo"></span>';
        cont.appendChild(b);
      });
      var img = h.el.querySelector('[data-mt-duo-img]');
      if (img && v.img && img.getAttribute('src') !== v.img) {
        if (animar) { img.classList.add('mt-cambio'); setTimeout(function () { img.src = v.img; img.classList.remove('mt-cambio'); }, 260); } else img.src = v.img;
      }
      h.el.querySelector('[data-mt-duo-nombre]').textContent = m.titulo + ' · ' + v.nombre;
      h.el.querySelector('[data-mt-duo-precio]').textContent = v.precio;
      h.id = v.id; h.cent = centimos(v.precio);
    }
    function total() {
      var suma = huecos.reduce(function (a, h) { return a + (h.cent || 0); }, 0), final = Math.round(suma * (1 - desc));
      antes.textContent = dinero(suma, formato);
      ahora.textContent = dinero(final, formato);
      ahorro.textContent = dinero(suma - final, formato);
      ahora.classList.remove('mt-salto'); ahora.offsetWidth; ahora.classList.add('mt-salto');
    }
    huecos.forEach(function (h) {
      h.el.addEventListener('click', function (e) {
        var mb = e.target.closest('.mt-duo__modelo'), d = e.target.closest('.mt-dial');
        if (mb) { h.p = +mb.dataset.p; h.v = 0; pintar(h, true); total(); }
        else if (d) { h.v = +d.dataset.i; pintar(h, true); total(); }
      });
      pintar(h, false);
    });
    total();
    btn.addEventListener('click', function () {
      var items = huecos.map(function (h) { return { id: Number(h.id), quantity: 1 }; });
      var drawer = document.querySelector('cart-drawer'), cuerpo = { items: items };
      if (drawer) { cuerpo.sections = 'cart-drawer,cart-icon-bubble'; cuerpo.sections_url = window.location.pathname; }
      btn.classList.add('mt-cargando');
      fetch(raiz + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(cuerpo) })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          btn.classList.remove('mt-cargando');
          if (drawer && j.sections && typeof drawer.renderContents === 'function') { drawer.classList.remove('is-empty'); drawer.renderContents(j); }
          else window.location.href = raiz + 'cart';
        })
        .catch(function () { window.location.href = raiz + 'cart'; });
    });
  }

  function iniciar() {
    document.querySelectorAll('[data-mt-cine]').forEach(initCine);
    var antes = letreros.length;
    document.querySelectorAll('[data-mt-letrero]').forEach(initLetrero);
    if (!antes && letreros.length && !reducido) requestAnimationFrame(bucleLetrero);
    document.querySelectorAll('[data-mt-viaje]').forEach(initViaje);
    document.querySelectorAll('[data-mt-duo]').forEach(initDuo);
    moverViajes();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
})();
